<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link v-if="prevRoute && prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMChatbotThreadsList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row v-if="item">
                <b-col>
                  <p class="m-0"><b>{{$t('views.excmchatbot.list.messageDateTime')}}:</b><span v-if="item.createdAt"> {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss') }}</span></p>
                  <p class="m-0"><b>{{$t('views.excmchatbot.list.subject')}}:</b> {{ item.subject }}</p>
                  <p class="m-0"><b>{{$t('views.excmchatbot.list.messageQuantity')}}:</b> {{ item.messages.length }}</p>
                  <p class="m-0"><b>{{$t('views.excmchatbot.list.idContractor')}}:</b>
                    <router-link v-if="item.idContractor && item.idContractor.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idContractor['@id'] }}">
                      {{ item.idContractor.name }} {{ item.idContractor.surname }}
                    </router-link>
                    <router-link v-else-if="item.idContractor" :to="{name: 'FirmShow', params: { id: item.idContractor['@id'] }}">
                      {{ item.idContractor.firmname1 === '' ? item.idContractor.fullName : item.idContractor.firmname1 }}
                    </router-link>
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-card>
          <b-row class="mt-2">
            <b-col cols="12">
              <h6>{{$t('views.excmchatbot.show.messages')}}:</h6>
            </b-col>
            <b-col cols="12" v-for="(threadMessage, threadMessageIndex) in item.messages" v-bind:key="'threadMessage-' + threadMessageIndex">
              <div class="card card-stats">
                <div class="card-body">
                  <div class="card-footer">
                    <b-row>
                      <b-col>
                        <p class="m-0"><b>{{$t('views.excmcyclictask.list.dateFrom')}}: </b>
                          <span v-if="threadMessage.isChatbotMessage">{{$t('views.excmchatbot.show.isChatbotMessage')}}</span>
                          <span v-else-if="item.idUserData">
                          <router-link v-if="item.idUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idUserData['@id'] }}">
                            <i style="color: #28a745" class="fa fa-arrow-right"></i>
                          </router-link>
                          <router-link v-else :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                            <i style="color: #28a745" class="fa fa-arrow-right"></i>
                          </router-link>
                          </span>
                          <span v-if="!threadMessage.isChatbotMessage">
                            <a :href="'mailto: ' + item.userEmailFromApplication"> {{ item.userEmailFromApplication }}</a>
                          </span>
                        </p>
                        <p class="m-0"><b>{{$t('views.excmdevicestate.list.table.date')}}: </b>{{$moment(threadMessage.messageDateTime).format('YYYY-MM-DD HH:mm:ss')}}</p>
                      </b-col>
                    </b-row>
                    <hr>
                  </div>
                  <div class="row">
                    <div class="col">
                      <p class="mx-4">{{threadMessage.message}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import getId from '@/utils/getIdFromLink'
import Loader from '../../Layout/Loader'
import { checkPermission } from '@/utils/checkRoles'

export default {
  components: {
    Loader
  },

  beforeDestroy () {
    this.reset()
  },
  data () {
    return {
      prevRoute: null,
      idRelatedChatbotMessageForCreateCase: null,
      idSenderTypeForCreateMessage: null,
      recipientForCreateMessage: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },
  watch: {
    '$route.params' () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    createdCase () {
      this.idRelatedChatbotMessageForCreateCase = null
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },
  computed: {
    ableToShowCase () {
      return checkPermission('cases', 'EXCMCaseShow')
    },
    ableToCreateCase () {
      return checkPermission('cases', 'EXCMCaseCreate')
    },
    ...mapGetters({
      deleteError: 'excmchatbot/del/error',
      error: 'excmchatbot/show/error',
      isLoading: 'excmchatbot/show/isLoading',
      item: 'excmchatbot/show/retrieved',
      createdCase: 'excmcase/create/created'
    }),
    mobileView () {
      return this.$store.state.mobileView
    }
  },
  methods: {
    showCreateCaseModal (idRelatedChatbotMessageForCreateCase) {
      this.idRelatedChatbotMessageForCreateCase = idRelatedChatbotMessageForCreateCase
      this.toggleCreateCaseModal()
    },
    createMessage (recipient, idSenderType) {
      this.recipientForCreateMessage = recipient
      this.idSenderTypeForCreateMessage = idSenderType
      this.toggleCreateMessageModal()
    },
    ...mapMutations({
      toggleCreateCaseModal: 'excmcase/createModal/toggleCreateCaseModal',
      toggleCreateMessageModal: 'excmmessage/createModal/toggleModal'
    }),
    ...mapActions({
      del: 'excmchatbot/del/del',
      reset: 'excmchatbot/show/reset',
      retrieve: 'excmchatbot/show/retrieve'
    }),
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
